import {
  convertToInlineStyle, getReactProps
} from '@m2h/common/utils/styleUtils';
import MachproHTMLElement from './common/machproHtmlElement';

const defaultClassName = 'machweb-modal';

export default class Modal extends MachproHTMLElement {
  private modal: null | HTMLElement
  constructor() {
    super();
    this.modal = null;
  }

  handleModalClick(event) {
    const reactProps = getReactProps(this);
    if (reactProps) {
      if (reactProps.onClick) {
        event.stopPropagation();
        reactProps.onClick(event);
      }
    }
    if (event.target.firstChild) {
      // @ts-ignore
      event.target.firstChild.click();
    }
    console.log('Modal', 123);
    // event.stopPropagation();
  }

  connectedCallback() {
    super.connectedCallback();
    let wrapClassName = '';
    if (!this.className) {
      wrapClassName = defaultClassName;
    } else {
      wrapClassName = `${this.className} ${defaultClassName}`;
    }
    this.className = '';
    // 创建模态容器
    this.modal = document.createElement('modal');
    this.modal.classList.add(wrapClassName);
    this.modal.style.cssText = this.style.cssText;

    // 将包裹的内容移动到 body
    while (this.firstChild) {
      this.modal.appendChild(this.firstChild);
    }
    this.modal.addEventListener('click', this.handleModalClick.bind(this));
    document.body.appendChild(this.modal);
  }

  // 移除
  disconnectedCallback() {
    if (this.modal && document.body.contains(this.modal)) {
      document.body.removeChild(this.modal);
    }
  }
}
